import * as React from 'react';
import { ContentWrapper } from '../ContentWrapper';
import { LandingBlock } from '../LandingBlock';
import { BlockHeader } from '../BlockHeader';

import * as styles from './styles.css';

export const ContactUs = () => {
  return (
    <LandingBlock>
      <ContentWrapper>
        <div className={styles['content']}>
          <div className={styles['image']} />
          <div className={styles['contact-us-block']}>
            <BlockHeader>Остались&nbsp;вопросы?</BlockHeader>
            <div className={styles['text-block']}>
              <span className={styles['text']}>Все вопросы про сервисы и заполнение анкеты</span>
              <span className={styles['text']}>можно задать здесь</span>
            </div>
            <div className={styles['contact-links-block']}>
              <a className={styles['contact-link']} href="tel:+78005513442">
                8 800 551-34-42
              </a>
              <a className={styles['contact-link']} href="mailto:ipoteka@cian.ru">
                ipoteka@cian.ru
              </a>
            </div>
          </div>
        </div>
      </ContentWrapper>
    </LandingBlock>
  );
};
